import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';

import { http, ProfileContext } from '@loyalup/core';
import { Layout, Button, useNotifications, AuthPanel } from '@loyalup/ui';

import { ReactComponent as CircleXIcon } from 'icons/circle-x.svg';
import { ReactComponent as CircleOkIcon } from 'icons/circle-ok.svg';

import s from './ConfirmEmail.module.css';

const STATUSES = {
  INVALID_TOKEN: 'invalid_token',
  SUCCESS: 'success',
  LOADING: 'loading',
};

const ConfirmEmail = ({ match, history }) => {
  const [t] = useTranslation();

  const { token } = match.params;
  const [status, setStatus] = useState(STATUSES.LOADING);
  const [userName, setUserName] = useState('');

  const hasUser = useContext(ProfileContext);

  const [sendNotification] = useNotifications();

  useEffect(() => {
    (async function() {
      const { ok, name } = await http('POST', '/confirm/email', { token });
      if (ok) {
        setStatus(STATUSES.SUCCESS);
        setUserName(name);
        sendNotification({ text: t('Ваш емейл подтвержден') });
        return history.push('/');
      } else {
        setStatus(STATUSES.INVALID_TOKEN);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hasUser && status === STATUSES.LOADING) return null;

  return (
    <Layout center title={t('Подтверждение почты')}>
      {status !== STATUSES.LOADING && (
        <AuthPanel>
          <div className={s.root}>
            <div className={s.header}>
              <h1>{t('Подтверждение почты')}</h1>
            </div>
            <div className={s.hintContainer}>
              {status === STATUSES.SUCCESS && (
                <>
                  <CircleOkIcon className={s.okIcon} />
                  <p className={s.hint}>
                    {t(
                      '{{name}}, ваш емейл подтвержден. Можете просто закрыть эту страницу или перейти на главную для продолжения работы.',
                      { name: userName },
                    )}
                  </p>
                </>
              )}
              {status === STATUSES.INVALID_TOKEN && (
                <>
                  <CircleXIcon className={s.xIcon} />
                  <p className={s.hint}>{t('Ваш емейл уже подтвержден или ссылка для подтверждения неверна.')}</p>
                </>
              )}
              <br />
              <br />
              <Button element={Link} to="/" className={s.button} fixedWidth={200} center>
                {t('На главную')}
              </Button>
            </div>
          </div>
        </AuthPanel>
      )}
    </Layout>
  );
};

export default withRouter(ConfirmEmail);
